// An automated test user's id carries an auto_test marker (e.g. auto_test-le64r81mscp802wwhrs1xqia),
// so the id alone identifies test traffic, with no need for the email or a logged-in container.
export const isAutomatedTestUserId = (userId: string | number | undefined): boolean => {
    return String(userId ?? '').includes('auto_test');
};

export const isAutomatedTests = (): boolean => {
    // Check localStorage flag
    if (localStorage.getItem('IS_AUTOMATED_TESTS') === 'true') {
        return true;
    }

    // Check if user email starts with 'auto_test-' (for staging/CI environments)
    try {
        // Access UserState via global IOC container
        const global: any = window;
        if (global.IOC) {
            const userState = global.IOC.get('UserState');
            if (userState && userState.state && userState.state.email) {
                return userState.state.email.startsWith('auto_test-');
            }
        }
    } catch (error) {
        // If UserState access fails, fall back to false
        return false;
    }

    return false;
};
